import {object, array, number} from 'yup';
import {messages} from '../../../../utils/messages';
import {PURCHASE_MIN_MONEY} from '../../../../business/keys';
import {ProductShape, currencyCode} from './product';

// Export schema
export const productBeginCheckout = object().shape({
  currencyCode,
  actionField: object().shape({
    revenue: number().min(PURCHASE_MIN_MONEY, messages.MIN_NUM),
  }).noUnknown(messages.NO_UNKNOWN),
  products: array().of(object().shape(ProductShape)).required(
    'productBeginCheckout requires an array of products.',
  ),
}).noUnknown(messages.NO_UNKNOWN);
